import { NgModule } from '@angular/core';
import { LottosListItemV2Component } from './lottos-list-item-v2/lottos-list-item-v2.component';
import { LottoDetailsV2Component } from './lotto-details-v2/lotto-details-v2.component';
import { LottosListV2Component } from './lottos-list-v2/lottos-list-v2.component';

@NgModule({
  declarations: [],
  imports: [LottoDetailsV2Component, LottosListItemV2Component, LottosListV2Component],
  exports: [LottoDetailsV2Component, LottosListItemV2Component, LottosListV2Component],
})
export class LottosV2Module {}
